import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, readAllTenant, listFilesUploaded, sendDataMohGenerate, changeViewForms, exportSelectMohsByName } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import './MohForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';

function MohEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit, toggleIsChangeFormElements } = getItensStateGlobal;

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [loadingMoh, setLoadingMoh] = useState(true);
  const [values, setValues] = useState({
    name: "",
    mode: "",
    directory: "",
    accountcode: "",
    sort: "",
  });
  const [originalName, setOriginalName] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [disableMusic, setDisableMusic] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [moh, setMohData] = useState({ name: '', tenant: '' });
  const [musicSelected, setMusicSelected] = useState([]);
  const [mohDataReceived, setMohDataReceived] = useState({});
  const { changeBorderImputToRedOrNormal, changeVisibityMessages } = changeViewForms;

  const fetchTenants = async (idtenant) => {
    try {
      let tenantsFetched = await readAllTenant();
      tenantsFetched = idtenant.includes('vgs') ? tenantsFetched : tenantsFetched.filter((tenant) => idtenant.includes(tenant.short_name));
      if (!tenantsFetched) return;
      setTenants(tenantsFetched);
    } catch (error) {
      console.error("Erro ao buscar tenants:", error);
    }
  };

  // const fetchMohList = async () => {
  //   try {
  //     let fetchMohData = await listFilesUploaded();
  //     setMohData(fetchMohData);
  //   } catch (error) {
  //     console.error("Erro ao buscar lista de músicas:", error);
  //   }
  // };

  const validateUserLogged = useCallback(async () => {
    try {
      const dataUser = accessLocalStorage.getUserLocalStorage();
      if (!dataUser) return history.push('/');
      
      const { user: { role, idtenant } } = dataUser;
      if (dataUser && role !== 'root') return history.push('/home');

      if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
        return history.push('/config/musica-de-espera/lista');
      };

      await fetchTenants(idtenant);
      const fetchMohData = await exportSelectMohsByName(itemsSelectedToEdit);

      if (fetchMohData.status !== 200) return history.push('/config/musica-de-espera/lista');
      setMohDataReceived(fetchMohData.data);
      // await fetchMohList();

      // Buscar os dados da música de espera selecionada
      // Em um caso real, você faria uma chamada de API para buscar os detalhes
      // Aqui estamos apenas simulando o carregamento
      
      // Extrair informações do nome da música (formato esperado: "moh-nome-tenant")
      const mohName = itemsSelectedToEdit;
      setOriginalName(mohName);

      setLoading(false);
      setLoadingMoh(false);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      history.push('/config/musica-de-espera/lista');
    }
  }, [history, itemsSelectedToEdit, moh]);

  const valuesAnalyse = (data) => {
    const { name, accountcode, mode, sort } = data;
    if(name.length > 0 && accountcode.length > 0 && mode.length > 0 && sort.length > 0) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
    
    if(mode === 'playlist' && !data.hasOwnProperty('music')) {
      setDisableButton(true);
    }
    if(mode === 'playlist' && data.hasOwnProperty('music')) {
      setDisableButton(false);
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    if (name === 'mode' && value === 'files') setDisableMusic(true);
    if (name === 'mode' && value === 'playlist') setDisableMusic(false);
    if (name === 'accountcode') moh.hasOwnProperty(value) ? setMusicSelected(moh[value].moh) : setMusicSelected([]);
    
    setValues((prevState) => {
      const setRealValues = { ...prevState, [name]: value };
      if (name === 'mode' && value === 'files') delete setRealValues.music;
      valuesAnalyse(setRealValues);
      return setRealValues;
    });
  };

  const analyseDataMohPreSend = () => {
    const realValues = values;
    realValues.name = `moh-${realValues.name}-${realValues.accountcode}`;
    if (realValues.mode === 'files') realValues.directory = `/opt/vigoscloud/api/uploads/moh/${realValues.accountcode}`;
    if (realValues.mode === 'playlist') {
      realValues.entry = `/opt/vigoscloud/api/uploads/moh/${realValues.accountcode}/${realValues.music}`;
      realValues.position = 0;
      realValues.directory = '';
    }
    
    // Adicionar o nome original para permitir atualização
    realValues.originalName = originalName;
    
    return realValues;
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const valuesToSend = analyseDataMohPreSend();
      const fetchSendMoh = await sendDataMohGenerate(valuesToSend);
      const result = Object.keys(fetchSendMoh).length > 0 ? true : false;
      
      if (result) {
        toggleIsChangeFormElements('alert-success-update', 'column is-half is-offset-one-quarter message is-success is-active');
        setTimeout(() => {
          history.push('/config/musica-de-espera/lista');
        }, 3000);
      } else {
        toggleIsChangeFormElements('alert-error-update', 'column is-half is-offset-one-quarter message is-danger is-active');
        setLoading(false);
      }
    } catch (error) {
      console.error("Erro ao atualizar música de espera:", error);
      toggleIsChangeFormElements('alert-error-update', 'column is-half is-offset-one-quarter message is-danger is-active');
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.push('/config/musica-de-espera/lista');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  useEffect(() => {
    // Revalidar botão quando valores mudam
    if (values) {
      valuesAnalyse(values);
    }
  }, [values]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-form-container">
          <div className="moh-form-header">
            <div className="moh-form-title-wrapper">
              <svg className="moh-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <div>
                <h1 className="moh-form-title">Editar Música de Espera</h1>
                <p className="moh-form-subtitle">Atualize as configurações da música de espera</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-error-update" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-error-update')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível atualizar a música de espera!
                <br />
                Verifique se os campos estão preenchidos corretamente.
              </div>
            </div>

            <div id="alert-success-update" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-success-update')}>×</button>
              </div>
              <div className="alert-body">
                Música de espera atualizada com sucesso!
              </div>
            </div>
          </div>

          <form name="edit-form" id="edit-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-card">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Nome</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="name" 
                      type="text"
                      defaultValue={mohDataReceived.name}
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Insira o nome da música de espera" 
                    />
                    <span name="name-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="accountcode"
                      defaultValue={mohDataReceived.accountcode}
                      onChange={(e) => handleChangeValues(e.target)} 
                    >
                      <option value="">Selecione</option>
                      {tenants.map((tenant) => (
                        <option key={`${tenant.accountcode}-${tenant.name}`} value={tenant.short_name}>
                          {tenant.name}
                        </option>
                      ))}
                    </select>
                    <span name="accountcode-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Tipo</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="mode"
                      defaultValue={mohDataReceived.mode}
                      onChange={(e) => handleChangeValues(e.target)} 
                    >
                      <option value="">Selecione</option>
                      <option value="files">Ler Pasta</option>
                      <option value="playlist">Música Única</option>
                    </select>
                    <span name="mode-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Ordenar</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="sort"
                      defaultValue={mohDataReceived.sort}
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="name">Nome</option>
                      <option value="random">Aleatório</option>
                    </select>
                    <span name="sort-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Música</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="music" 
                      defaultValue={mohDataReceived.music || ""}
                      onChange={(e) => handleChangeValues(e.target)} 
                      disabled={disableMusic}
                    >
                      <option value="">Selecione</option>
                      {loadingMoh ? (
                        <option value="" disabled>Carregando...</option>
                      ) : (
                        musicSelected.map((music) => (
                          <option key={music} value={music.split('.')[0]}>
                            {music.split('.')[0]}
                          </option>
                        ))
                      )}
                    </select>
                    <span name="music-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <Link to="/config/musica-de-espera/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faTimes} />
                  Cancelar
                </Link>
                <button 
                  className="btn-submit" 
                  onClick={handleSubmit}
                  disabled={disableButton}
                >
                  <FontAwesomeIcon icon={faSave} />
                  Salvar Alterações
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default MohEdit; 